import { LoginSettings } from '@/entities/profile-page/settingsProfile/LoginSettings/ui/LoginSettings'
import './ui/LoginSettings.scss'
export default LoginSettings
